import { useQuery } from '@tanstack/react-query';
import { childService } from '@/api/services/child.service';

export default function useChild(id?: string | number) {
  const isEnabled = id !== undefined && id !== null && (typeof id !== 'number' || !isNaN(id));

  return useQuery({
    queryKey: [`child-${id}`],
    queryFn: () => childService.getChild(id!),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    retry: 1,
    enabled: isEnabled,
  });
}
